import { useState } from 'react';
import { useAsyncEffect } from './useAsyncEffect';
import { useClient } from '../context/client';

export function useVehicleList() {
	const [isLoading, setIsLoading] = useState(false);
	const [vehicles, setVehicles] = useState([]);
	const client = useClient();

	useAsyncEffect(async () => {
		try {
			setIsLoading(true);
			setVehicles(await client.getVehicles());
		} catch (err) {
			console.error(err);
		} finally {
			setIsLoading(false);
		}
	});

	return [isLoading, vehicles];
}
